<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" class="plot-aro" (click)="windowClick()">
 
  <dialog-header 
    [label]= '"Sensor-Vector"'
    [dialogRef]='dialogRef' 
    [object]='this'
    [objectType]='"Sensor"' (mousedown)="windowClick()">
  </dialog-header>

  <!-- Icon area -->
  <mat-card class="box-bottom-padding-and-border" style="height: 130;">
    <mat-grid-list cols="15" rowHeight="130">
      
      <mat-grid-tile colspan="7">
        <div fxLayout="column" fxLayoutAlign="center center">
          <div class="vector-container">
            <img src="./assets/Images/plane-circle.svg" class="circle-image" />           
            <div class="vector-image" [style.background-color]="cssColor" [style.-webkit-mask-image]="'url(../../assets/Images/vector-aro-icon.svg)'"  [style.transform]="getRotation()"> </div>           
            <!-- <img class="vector-image" src="./assets/Images/vector-aro-icon.svg" [style.transform]="getRotation()" [style.color]="cssColor" /> -->
          </div>        
        </div>
      </mat-grid-tile>

      <mat-grid-tile colspan="8" style="right: auto; width: inherit;">
        <div fxFlex="100%" fxLayout="column" fxLayoutAlign="center center">
          
          <div style="margin-top: 5px;"></div>
          <div> {{time}} </div>
          <div class="aro-label"> {{'ARO.LAST_UPDATED' | translate}} </div>
          &emsp;
          <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="space-evenly">
            <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
              <div class="plot-basic-data-value" > {{ angle }} </div>
              <div class="aro-label" style="word-break: unset;"> Angle </div>
            </div>
          </div>
        </div>
      </mat-grid-tile>
     
    </mat-grid-list>
  </mat-card>

  <!-- Middle card -->
  <mat-card class="box-bottom-padding-and-border">    
    <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
      <div class="plot-basic-data-value">{{ f0 }}</div>
      <div class="aro-label">F0</div>
    </div>
    <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
      <div class="plot-basic-data-value">{{ snr }}</div>
      <div class="aro-label">SNR</div>
    </div>
  </mat-card>

  <mat-card class="box-bottom-padding-and-border">    
    <div fxFlex="100%" fxLayout="column" fxLayoutAlign="center center">
      <div class="plot-basic-data-value">{{ cls }}</div>
      <div class="aro-label">Classification</div>
    </div>
  </mat-card>

  <!-- Altitude/Time/Radar data -->
  <mat-card class="box-bottom-padding-and-border">
    <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="space-evenly">
      <div fxFlex="33.3%" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px" [matTooltip]="'Amplitude'"
      [matTooltipPosition]="'above'" >
        <!-- <img matTooltip="Amplitude" class="plot-basic-data-icon" class="aro-amp-icon" src="./assets/Images/vector-aro-amp-icon.svg" /> -->
        <app-amplitudeimage></app-amplitudeimage>
        <div class="plot-basic-data-value">{{ amplitude }}</div>
      </div>
      <div fxFlex="33.3%" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px" [matTooltip]="'Max Frequency Energy'"
      [matTooltipPosition]="'above'">
        <div *ngIf="maxfreqEnergy <= 60">
          <app-lowfreqimage></app-lowfreqimage>
        </div>
        <div *ngIf="maxfreqEnergy > 60 && maxfreqEnergy <= 150" >
          <app-midfreqimage></app-midfreqimage>
        </div>
        <div *ngIf="maxfreqEnergy > 150">
          <app-highfreqimage></app-highfreqimage>
        </div>
        <div class="plot-basic-data-value">{{ maxfreqEnergy }} Hz</div>     
      </div>
      <div fxFlex="33.3%" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">        
        <!-- <img matTooltip="Sensor ID" class="plot-basic-data-icon" src="./assets/Images/plot-aro-radar-icon.svg" [matTooltip]="'Sensor ID'" [matTooltipPosition]="'above'"/> -->
        <app-sensorimage></app-sensorimage>
        <div class="plot-basic-data-value">{{sensorId}}({{sensorSymbol}})</div>
      </div>
    </div>
  </mat-card>